import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { addBuddyRatingAPIRequest, fetchBuddyDetailsAPIRequest, fetchUniversityDetailsAPIRequest } from "./AddBuddyRatingAPI"
import { RootState } from "../../../store"

interface BuddyRatingStatus {
    isFetching?: boolean,
    statusAdd?: 'IDLE' | "PENDING" | "SUCCESS" | 'FAILED',
    statusGet?: 'IDLE' | "PENDING" | "SUCCESS" | 'FAILED',
    statusGetBuddy?: 'IDLE' | "PENDING" | "SUCCESS" | 'FAILED',
    responseAdd?: {},
    resoponseGet?: {},
    responseGetBuddy?: {}
}

export interface AddBuddyRatingProps {
    name? : string,
    comment? : string,
    ratings?: number,
    prospectPublicId?: string,
    buddyPublicId?: string
}

export interface GetUniversityDetailsProps {
    uniId? : string
}

export interface GetBudyDetailsProps {
    buddyPublicId: string,
    prospectPublicId?: string,
}

// Define the initial state using that type
const initialState: BuddyRatingStatus = {
    statusAdd: "IDLE",
    statusGet: "IDLE",
    responseAdd: {},
    resoponseGet: {},
    isFetching: false,
    statusGetBuddy: 'IDLE',
    responseGetBuddy: {}
}

export const addBuddyRatingRequest = createAsyncThunk(
    'add/buddy/rating',
    async (rating:AddBuddyRatingProps) => {
        return await addBuddyRatingAPIRequest(rating)
    }
);

export const fetUniversityDetailsRequest = createAsyncThunk(
    'get/university/details',
    async (uniId:GetUniversityDetailsProps) => {
        return await fetchUniversityDetailsAPIRequest(uniId)
    }
);


export const fetchBuddyDetailsRequest = createAsyncThunk(
    'get/buddy/details',
    async (publicIds:GetBudyDetailsProps) => {
        return await fetchBuddyDetailsAPIRequest(publicIds)
    }
);

// Then, handle actions in your reducers:
const BuddyRatingSlice = createSlice({
    name: 'buddyRating',
    initialState: initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
        clearAddRatingRes: (state) => {
            state.isFetching = false    
            state.statusAdd = "IDLE"
            state.responseAdd = {}
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder
            .addCase(fetUniversityDetailsRequest.pending, (state) => {
                state.statusGet = 'PENDING';
                state.isFetching = true;
            })
            .addCase(fetUniversityDetailsRequest.fulfilled, (state, action) => {
                // Add user to the state array
                state.statusGet = 'SUCCESS';
                state.isFetching = false;
                state.resoponseGet = action.payload;
            })
            .addCase(fetUniversityDetailsRequest.rejected, (state) => {
                state.statusGet = 'FAILED';
                state.isFetching = false;
            })
            .addCase(addBuddyRatingRequest.pending, (state) => {
                state.statusAdd = 'PENDING';
                state.isFetching = true;
            })
            .addCase(addBuddyRatingRequest.fulfilled, (state, action) => {
                // Add user to the state array
                state.statusAdd = 'SUCCESS';
                state.isFetching = false;
                state.responseAdd = action.payload;
            })
            .addCase(addBuddyRatingRequest.rejected, (state) => {
                state.statusAdd = 'FAILED';
                state.isFetching = false;
            })
            .addCase(fetchBuddyDetailsRequest.pending, (state) => {
                state.statusGetBuddy = 'PENDING';
                state.isFetching = true;
            })
            .addCase(fetchBuddyDetailsRequest.fulfilled, (state, action) => {
                // Add user to the state array
                state.statusGetBuddy = 'SUCCESS';
                state.isFetching = false;
                state.responseGetBuddy = action.payload;
            })
            .addCase(fetchBuddyDetailsRequest.rejected, (state) => {
                state.statusGetBuddy = 'FAILED';
                state.isFetching = false;
            })
    },
})

export const buddyRatingSelector = (state: RootState) => state.buddyRating;
export default BuddyRatingSlice.reducer

